const input = {
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    email: 'البريد الإلكتروني',
    phone_number: 'رقم الهاتف',
    student_number: 'رقم الطالب',
    registration_number: 'رقم التسجيل',
    student_identifier_legend: 'تسجيل الدخول باستخدام',
    confirm_password: 'تأكيد كلمة المرور',
    search_region_code: 'رمز منطقة البحث',
    backup_code: 'رمز النسخ الاحتياطي',
    code: 'الرمز',
    label_with_optional: '(اختياري) {{label}}',
};
export default Object.freeze(input);
